import React from 'react';

import SystemNoticePage from 'components/composites/SystemNoticePage';

export default function SiteUnderMaintenance() {
  return (
    <SystemNoticePage
      helmetSection="Site Under Management"
      title="Our site is currently under maintenance. Apologies for any inconvenience. We will be back soon."
    />
  );
}
